import { tr } from "../i18n/LanguageContext";
// Supported online meeting platforms.
// `key` is stored in the DB (Event.meetingPlatform); `label` is shown in the UI.
// Adding a new platform is just adding a row here — no other code changes required.
export const meetingPlatforms = [
  { key: "telegram", label: "Telegram" },
  { key: "zoom", label: "Zoom" },
  { key: "google_meet", label: "Google Meet" },
  { key: "microsoft_teams", label: "Microsoft Teams" },
  { key: "jitsi", label: "Jitsi" },
  { key: "discord", label: "Discord" },
  { key: "other", label: "Other" },
];

// Fallback label for events that have no platform stored (e.g. legacy events
// created before the field existed). The interface keeps working — we just
// call it a generic "Онлайн встреча".
export const FALLBACK_PLATFORM_LABEL = "Онлайн встреча";

export function getMeetingPlatformLabel(key) {
  if (!key) return tr(FALLBACK_PLATFORM_LABEL);
  const found = meetingPlatforms.find((p) => p.key === key);
  return tr(found ? found.label : FALLBACK_PLATFORM_LABEL);
}
